import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["warning", "emailInput"]
  static values = {
    currentUserEmail: String
  }

  connect() {
    this.checkEmailMismatch()
  }

  checkEmailMismatch() {
    if (!this.hasCurrentUserEmailValue || !this.currentUserEmailValue) {
      return
    }

    if (!this.hasEmailInputTarget) {
      return
    }

    const enteredEmail = this.emailInputTarget.value.trim().toLowerCase()
    const currentEmail = this.currentUserEmailValue.trim().toLowerCase()

    if (!enteredEmail) {
      this.hideWarning()
      return
    }

    if (enteredEmail !== currentEmail) {
      this.showWarning(enteredEmail)
    } else {
      this.hideWarning()
    }
  }

  showWarning(enteredEmail) {
    if (!this.hasWarningTarget) return

    this.warningTarget.classList.remove("hidden")

    const emailSpan = this.warningTarget.querySelector("[data-entered-email]")
    if (emailSpan) {
      emailSpan.textContent = enteredEmail
    }
  }

  hideWarning() {
    if (!this.hasWarningTarget) return

    this.warningTarget.classList.add("hidden")
  }
}
